import { render } from "./ExpandedSettings.vue?vue&type=template&id=120be57a&scoped=true&ts=true&lang=pug"
import script from "./ExpandedSettings.vue?vue&type=script&lang=ts"
export * from "./ExpandedSettings.vue?vue&type=script&lang=ts"

import "./ExpandedSettings.vue?vue&type=style&index=0&id=120be57a&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120be57a"]])

export default __exports__